import { defineMessages } from 'react-intl';

export default defineMessages({
  authenticationError: {
    description: 'Authentication Error',
    defaultMessage: 'An error occurred while authenticating the store.',
    id: 'c7SV+C',
  },
  cancel: {
    description: 'Cancel Button Message',
    defaultMessage: 'Cancel',
    id: 'W1U/rf',
  },
  reauthenticateButton: {
    description: 'Reauthenticate Button Message',
    defaultMessage: 'Reauthenticate',
    id: '1bbRVC',
  },
});
